document.addEventListener("DOMContentLoaded", function() {
  const note = document.getElementById("on-demand-note");
  if (!note) return;

  const invEl = document.getElementById("VariantInventoryJSON");
  if (!invEl) return;

  const inventoryData = JSON.parse(invEl.textContent);

  function updateNote(variantId) {
    const item = inventoryData.find(v => String(v.id) === String(variantId));
    if (!item) {
      note.style.display = "none";
      return;
    }

    const isOnDemand =
      item.inventory_policy === "continue" &&
      item.inventory_quantity <= 0;

    note.style.display = isOnDemand ? "" : "none";
  }

  // Sélecteur Shopify standard mis à jour par Radiant
  const idInput = document.querySelector('input[name="id"]');
  if (!idInput) return;

  // Mise à jour initiale
  updateNote(idInput.value);

  // Radiant déclenche "change" et "input" sans detail.variant
  idInput.addEventListener("change", () => updateNote(idInput.value));
  idInput.addEventListener("input", () => updateNote(idInput.value));
});
